/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportUserResponseItem
 */
export interface ImportUserResponseItem {
    /**
     * 
     * @type {boolean}
     * @memberof ImportUserResponseItem
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportUserResponseItem
     */
    isNew?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportUserResponseItem
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserResponseItem
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserResponseItem
     */
    userId?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportUserResponseItem
     */
    createdAt?: number;
}

/**
 * Check if a given object implements the ImportUserResponseItem interface.
 */
export function instanceOfImportUserResponseItem(value: object): value is ImportUserResponseItem {
    return true;
}

export function ImportUserResponseItemFromJSON(json: any): ImportUserResponseItem {
    return ImportUserResponseItemFromJSONTyped(json, false);
}

export function ImportUserResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportUserResponseItem {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'isNew': json['isNew'] == null ? undefined : json['isNew'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'email': json['email'] == null ? undefined : json['email'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function ImportUserResponseItemToJSON(json: any): ImportUserResponseItem {
    return ImportUserResponseItemToJSONTyped(json, false);
}

export function ImportUserResponseItemToJSONTyped(value?: ImportUserResponseItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'isNew': value['isNew'],
        'errorMessage': value['errorMessage'],
        'email': value['email'],
        'userId': value['userId'],
        'createdAt': value['createdAt'],
    };
}

